import { render, staticRenderFns } from "./ShareGroups.vue?vue&type=template&id=6a47b6f9&scoped=true"
import script from "./ShareGroups.vue?vue&type=script&lang=js"
export * from "./ShareGroups.vue?vue&type=script&lang=js"
import style0 from "./ShareGroups.vue?vue&type=style&index=0&id=6a47b6f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a47b6f9",
  null
  
)

export default component.exports